import React from 'react';

class TotalsTableYearlyRow extends React.Component {

  render() {
  	const {YearStart, YearEnd, TicketQty, OrderSum, PaymentFees, PointName, Username} = this.props.data;
    const {activecols} = this.props;
    
    return (
      <tr>
        <td>{YearStart}</td>
        <td>{YearEnd}</td>
        <td>{TicketQty}</td>
        <td>{OrderSum}</td>
        <td>{PaymentFees}</td>
        {activecols.pointName && <td>{PointName}</td>}
        {activecols.username && <td>{Username}</td>}
      </tr>
    );
  }
}

export default TotalsTableYearlyRow;
